<template>
  <div>
    <div class="tabs is-boxed">
      <ul>
        <li>
          <router-link :to="{ name: 'withdrawal-requests' }" active-class="is-active" tag="li"><a>Withdrawal Requests</a></router-link>
        </li>
        <li>
          <router-link :to="{ name: 'operations-awaiting-antifraud' }" active-class="is-active" tag="li"><a>Operations Awaiting Anti Fraud Action</a></router-link>
        </li>
      </ul>
    </div>
    <router-view />
  </div>
</template>

<script>

  export default {
    name: "payment-system"
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/components/payment-system/index.vue